module.exports = __webpack_public_path__ + "img/course_bg_mb.478ea6de.webp";